import { z } from 'zod';

import { URL_TILE_SEARCH_PARAM } from '../../url-tiles/types';

export const TASK_CLUSTER_NAVIGATION_STATE = { taskClusterNavigation: true } as const;
const taskClusterNavigationStateSchema = z.object({ taskClusterNavigation: z.literal(true) });

export const taskClusterNavigationKey = (location: {
    readonly key: string;
    readonly state: unknown;
}): string | undefined =>
    taskClusterNavigationStateSchema.safeParse(location.state).success ? location.key : undefined;

export const createTaskClusterUrl = ({
    architectureId,
    clusterId,
    tileValues,
}: {
    readonly architectureId: string;
    readonly clusterId: string;
    readonly tileValues: readonly string[];
}): string => {
    const params = new URLSearchParams({ architectureId, clusterId });
    for (const tile of tileValues) {
        params.append(URL_TILE_SEARCH_PARAM, tile);
    }

    return `/tasks?${params.toString()}`;
};
